/* @flow */

import type { $Configuration } from '../types/Configuration';

export const getSearchProfileRelatedConfigurationsList = (
  searchProfileName: string, configurationsList: ?Array<$Configuration>
): Array<$Configuration> => {
  return configurationsList ? configurationsList.filter((configuration: $Configuration) => {
    if (configuration && configuration.baseInfo && configuration.baseInfo.searchProfileNames) {
      return configuration.baseInfo.searchProfileNames.includes(searchProfileName);
    }
  }) : [];
};

export function debounceFunction(fn: Function, wait: number) {
	let timer;
  let resolveList = [];

	return function (...arguments_: Array<any>): Promise<any> {
		return new Promise(resolve => {

			if(timer) clearTimeout(timer);

			timer = setTimeout(() => {
        timer = null;
				const result = fn.apply(this, arguments_);

				for (resolve of resolveList) {
					resolve(result);
				}

				resolveList = [];
			}, wait);

			resolveList.push(resolve);
		});
	};
}
